import { apiDelete, apiGet, apiPost } from '../../../shared/api-client/index.js';

export type CalendarIntegrationProvider = 'google' | 'outlook';

export interface CalendarConnectionSummary {
  id: string;
  provider: CalendarIntegrationProvider;
  accountEmail: string;
  accountName: string | null;
  status: 'active' | 'suspended' | 'revoked' | 'error';
  lastSyncedAt: string | null;
  lastErrorCode: string | null;
}

export interface CalendarIntegrationsState {
  available: boolean;
  providers: Record<CalendarIntegrationProvider, boolean>;
  connections: CalendarConnectionSummary[];
}

export const calendarIntegrationsQueryKey = (workspaceId: string) =>
  ['calendar-integrations', workspaceId] as const;

export const getCalendarIntegrations = (): Promise<CalendarIntegrationsState> =>
  apiGet('/integrations/calendars');

export const startCalendarConnect = (
  provider: CalendarIntegrationProvider,
): Promise<{ authorizeUrl: string }> => apiPost(`/integrations/calendars/${provider}/connect`, {});

export async function disconnectCalendarConnection(connectionId: string): Promise<void> {
  await apiDelete(`/integrations/calendars/${encodeURIComponent(connectionId)}`);
}
